<app-voucher-titulo></app-voucher-titulo>
<div>
  <form (submit)="irParaTelaResgatarVouchers()" class="col-xs-12 col-md-6 col-md-offset-3" ngNativeValidate>
    <div class="form-group">
      <label>Número do Voucher atual</label>
      <input type="text" class="form-control imput-sm" [ngModel]="voucherService?.voucherPrincipal?.getNumero()" name="numero" readonly
        required>
    </div>
    <div class="form-group">
      <label for="saldoPontos">Informe a quantidade de Pontos do Voucher</label>
      <input type="text" class="form-control imput-sm" id="saldoPontos" [ngModel]="voucherService?.voucherPrincipal?.getSaldoPontos()"
        (ngModelChange)="voucherService?.voucherPrincipal?.setSaldoPontos($event)" name="saldoPontos" required UiPontos>
    </div>
    <button type="submit" class="btn app-btn-best">
      Confirmar
    </button>
  </form>
</div>


// WEBPACK FOOTER //
// ./src/app/voucher/voucher-confirmar/voucher-confirmar.component.html